/* =====================================================================
   ROGER'S — HOME REDESIGN (JS isolado, escopo rgh)
   Carregado globalmente após rogers-custom.js
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- 1) HERO carousel ---------- */
  function initHero(root) {
    var track = root.querySelector('.rgh-hero__track');
    var slides = root.querySelectorAll('.rgh-hero__slide');
    var bulletsWrap = root.querySelector('.rgh-hero__bullets');
    var total = slides.length;
    if (!track || total === 0) return;

    var index = 0;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    // marca o primeiro como ativo (para o zoom)
    slides[0].classList.add('is-active');

    if (total <= 1) {
      if (bulletsWrap) bulletsWrap.style.display = 'none';
      return;
    }

    // bullets
    var bullets = [];
    if (bulletsWrap) {
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir para o slide ' + (i + 1));
        if (i === 0) b.classList.add('is-active');
        (function (idx) {
          b.addEventListener('click', function () { go(idx); restart(); });
        })(i);
        bulletsWrap.appendChild(b);
        bullets.push(b);
      }
    }

    function go(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      bullets.forEach(function (el, bi) { el.classList.toggle('is-active', bi === index); });
    }
    function next() { go(index + 1); }

    var timer = setInterval(next, interval);
    function restart() { clearInterval(timer); timer = setInterval(next, interval); }
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
  }

  function init() {
    document.querySelectorAll('.rgh-hero').forEach(initHero);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* ---------- 2) Frete por CEP (faixa + badges nos cards) ---------- */
  // UF com frete grátis a partir de R$300 (Sul, Sudeste, Centro-Oeste + BA/CE). Demais => R$1.000.
  var THR_300 = ['SP','RJ','MG','ES','PR','SC','RS','GO','MT','MS','DF','BA','CE'];
  // Estimativa de prazo por região (dias úteis) — comunicação na navegação.
  var DAYS = {
    SP:[2,5], RJ:[3,7], MG:[3,7], ES:[3,8],
    PR:[3,7], SC:[4,8], RS:[4,9],
    GO:[4,8], MT:[5,10], MS:[5,10], DF:[4,8],
    BA:[5,10], CE:[6,12], PE:[6,12], RN:[6,12], PB:[6,12], AL:[6,12], SE:[6,12], MA:[7,13], PI:[7,13],
    PA:[8,15], AM:[8,16], AC:[10,18], RO:[9,16], RR:[10,18], AP:[10,18], TO:[7,14]
  };
  function rghThreshold(uf) {
    if (!uf) return 300;
    return THR_300.indexOf(String(uf).toUpperCase()) >= 0 ? 300 : 1000;
  }
  function rghGetCep() {
    try { return JSON.parse(localStorage.getItem('rg_cep')); } catch (e) { return null; }
  }
  function rghMoney(v) { return 'R$ ' + Number(v).toLocaleString('pt-BR'); }

  function rghRenderBar() {
    var bars = document.querySelectorAll('.rgh-cepbar');
    if (!bars.length) return;
    var o = rghGetCep();
    var uf = o && o.uf ? String(o.uf).toUpperCase() : '';
    var city = o && o.city ? o.city : '';
    var approx = o && o.approx;
    var thr = rghThreshold(uf);
    bars.forEach(function (bar) {
      var locEl = bar.querySelector('.rgh-cepbar__loc');
      var thrEl = bar.querySelector('.rgh-cepbar__thr');
      var daysEl = bar.querySelector('.rgh-cepbar__days');
      if (locEl) {
        locEl.textContent = city
          ? (approx ? 'Estimado para ' : 'Enviar para ') + city + (uf ? ', ' + uf : '')
          : 'Informe seu CEP';
      }
      if (thrEl) { thrEl.textContent = 'Frete grátis acima de ' + rghMoney(thr); }
      if (daysEl) {
        var d = uf && DAYS[uf];
        if (d) { daysEl.textContent = 'Entrega em ' + d[0] + '–' + d[1] + ' dias úteis'; daysEl.hidden = false; }
        else { daysEl.hidden = true; }
      }
    });
  }

  function rghRenderBadges() {
    var cards = document.querySelectorAll('.rgh-prodcard[data-price], .rgh-gg__prod[data-price]');
    if (!cards.length) return;
    var o = rghGetCep();
    var thr = rghThreshold(o && o.uf);
    cards.forEach(function (card) {
      var price = parseFloat(card.getAttribute('data-price')) || 0;
      var badge = card.querySelector('.rgh-prodcard__freight, .rgh-gg__prod-freight');
      if (badge) badge.hidden = !(price >= thr);
    });
  }

  function rghRenderFreight() { rghRenderBar(); rghRenderBadges(); }

  window.addEventListener('rg:cepchange', rghRenderFreight);
  // fallback: re-render após interação com o popover de CEP do header
  document.addEventListener('click', function (e) {
    if (e.target && (e.target.id === 'rg-cep-ok' || e.target.id === 'rg-cep-geo')) {
      setTimeout(rghRenderFreight, 700);
    }
  });
  if (document.readyState !== 'loading') rghRenderFreight();
  else document.addEventListener('DOMContentLoaded', rghRenderFreight);

  /* ---------- 3) Card: seleção de numeração + adicionar ao carrinho ---------- */
  function rghOpenCartFromData(data) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function') {
      // remove 'is-empty' antes de abrir para o tema achar o container de foco (#CartDrawer)
      cd.classList.remove('is-empty');
      cd.renderContents(data);
      return;
    }
    var cn = document.querySelector('cart-notification');
    if (cn && typeof cn.renderContents === 'function') {
      cn.renderContents(data);
      return;
    }
    window.location = '/cart';
  }

  function rghAddToCart(variantId, btn) {
    var label = btn.querySelector('.rgh-prodcard__buy-label');
    var orig = label ? label.textContent : '';
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) {
          if (label) label.textContent = 'Indisponível';
          setTimeout(function () { if (label) label.textContent = orig; }, 1800);
          return;
        }
        if (label) label.textContent = 'Adicionado';
        btn.classList.add('is-done');
        rghOpenCartFromData(res.j);
        setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = orig; }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (label) { label.textContent = 'Tente de novo'; setTimeout(function () { label.textContent = orig; }, 1800); }
      });
  }

  function rghInitCards() {
    document.querySelectorAll('.rgh-prodcard').forEach(function (card) {
      if (card.__rghInit) return;
      card.__rghInit = true;
      var sizeBtns = card.querySelectorAll('.rgh-prodcard__size');
      var sizesWrap = card.querySelector('.rgh-prodcard__sizes');
      var buyBtn = card.querySelector('.rgh-prodcard__buy');
      var selected = null;
      sizeBtns.forEach(function (b) {
        if (b.disabled) return;
        b.addEventListener('click', function () {
          sizeBtns.forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          selected = b.getAttribute('data-vid');
        });
      });
      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          var hasSizes = sizeBtns.length > 0;
          if (hasSizes && !selected) {
            if (sizesWrap) { sizesWrap.classList.remove('rgh-shake'); void sizesWrap.offsetWidth; sizesWrap.classList.add('rgh-shake'); }
            return;
          }
          var vid = selected || card.getAttribute('data-default-vid');
          if (vid) rghAddToCart(vid, buyBtn);
        });
      }
    });
  }

  /* ---------- 3b) Card: alterna as imagens do produto no hover (desktop) ---------- */
  function rghInitCardGallery() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.rgh-prodcard[data-imgs]').forEach(function (card) {
      if (card.__rghGal) return;
      card.__rghGal = true;
      var img = card.querySelector('.rgh-prodcard__imgwrap img');
      if (!img) return;
      var list = (card.getAttribute('data-imgs') || '').split('|').filter(Boolean);
      if (list.length < 2) return;
      var base = img.getAttribute('src'), baseSrcset = img.getAttribute('srcset');
      var timer = null, idx = 0, preloaded = false;
      function restoreSrcset() { if (baseSrcset) { img.setAttribute('srcset', baseSrcset); } else { img.removeAttribute('srcset'); } }
      card.addEventListener('mouseenter', function () {
        if (!preloaded) { list.forEach(function (u) { var im = new Image(); im.src = u; }); preloaded = true; }
        clearInterval(timer); idx = 0;
        timer = setInterval(function () { idx = (idx + 1) % list.length; img.src = list[idx]; img.setAttribute('srcset', list[idx] + ' 600w'); }, 850);
      });
      card.addEventListener('mouseleave', function () {
        clearInterval(timer); timer = null; idx = 0; img.src = base; restoreSrcset();
      });
    });
  }

  function rghCardsBoot() { rghInitCards(); rghInitCardGallery(); }
  if (document.readyState !== 'loading') rghCardsBoot();
  else document.addEventListener('DOMContentLoaded', rghCardsBoot);

  /* ---------- 4) Linhas Especiais (timer circular + banner) ---------- */
  function rghInitLinhas(root) {
    var tabs = root.querySelectorAll('.rgh-le__tab');
    var panels = root.querySelectorAll('.rgh-le__panel');
    var n = tabs.length;
    if (n === 0) return;
    var strip = root.querySelector('.rgh-le__tabs');
    var prevBtn = root.querySelector('.rgh-le__arrow--prev');
    var nextBtn = root.querySelector('.rgh-le__arrow--next');
    if (n === 1) { tabs[0].classList.add('is-active'); if (panels[0]) panels[0].classList.add('is-active'); return; }
    var dur = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var idx = 0, timer = null;
    function ensureVisible(i) {
      if (!strip || strip.scrollWidth <= strip.clientWidth + 4) return;
      var t = tabs[i]; if (!t) return;
      if (t.offsetLeft < strip.scrollLeft || t.offsetLeft + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    function show(i) {
      idx = (i % n + n) % n;
      tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      panels.forEach(function (p, k) { p.classList.toggle('is-active', k === idx); });
      // Reinicia o anel do tab ativo do ZERO a cada troca. Sem isso, quando uma marca
      // já vista volta a ficar ativa, o navegador não reinicia a animação CSS na hora
      // (fica ~1s parada vazia e "salta") — o truque animation:none + reflow força o restart limpo.
      // Com animation:'' ele volta a herdar o CSS, que só anima se a seção tiver .is-visible (gate do timer).
      var ap = tabs[idx].querySelector('.rgh-le__ring-progress');
      if (ap) { ap.style.animation = 'none'; void ap.offsetWidth; ap.style.animation = ''; }
      ensureVisible(idx);
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, dur); }
    // setas: vão para a marca anterior/próxima e dão a volta (sem ficar "no limbo")
    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); start(); });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); start(); }); });
    show(0);
    // Preload dos banners um pouco ANTES da seção aparecer → evita o 1º painel (ex.: Nike) ficar "travado"/em branco
    // enquanto a imagem de 2000px carrega. Dispara a ~600px de distância e só uma vez.
    function rghLePreload() {
      panels.forEach(function (p) {
        var img = p.querySelector('img.rgh-le__bg');
        if (img) { img.loading = 'eager'; var pre = new Image(); pre.src = img.currentSrc || img.src; }
      });
    }
    if ('IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { rghLePreload(); pio.disconnect(); }
      }, { rootMargin: '600px 0px' });
      pio.observe(root);
    } else { rghLePreload(); }
    // Autoplay só roda quando a seção está visível na tela — evita avançar e rolar a faixa
    // enquanto o cliente ainda nem chegou na seção (no mobile a home é longa).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            // Só dispara uma vez por entrada (idempotente) — evita o observer re-chamar start()
            // e dessincronizar o timer JS do anel CSS enquanto a seção continua na tela.
            if (!root.classList.contains('is-visible')) {
              root.classList.add('is-visible'); // libera o anel (timer visual) SÓ ao entrar na seção
              show(idx);                          // reinicia o anel do tab atual do zero, já visível
              start();
            }
          } else {
            root.classList.remove('is-visible');
            clearInterval(timer);
          }
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      root.classList.add('is-visible');
      start();
    }
  }
  function rghLinhasInit() { document.querySelectorAll('.rgh-le').forEach(rghInitLinhas); }
  if (document.readyState !== 'loading') rghLinhasInit();
  else document.addEventListener('DOMContentLoaded', rghLinhasInit);

  /* ---------- 4a) FIX Ordenação x Filtro (coleção + busca) ----------
     O sort visível na toolbar (#SortBy / form FacetSortDrawerForm) NÃO carrega os filtros ativos:
     ao ordenar, o facets.js montava a URL só com sort_by e PERDIA o filtro aplicado.
     Solução: delegação em document (capture, sobrevive aos re-renders do AJAX) — intercepta o
     #SortBy ANTES do facets.js e roteia pro sort do DRAWER (#SortBy-mobile), que mescla os
     filtros ativos (mantém o AJAX). Se não houver o do drawer, navega preservando os parâmetros. */
  (function rghSortKeepsFilters() {
    if (window.__rghSortFix) return;
    window.__rghSortFix = true;
    function isToolbarSort(t) { return t && t.tagName === 'SELECT' && t.id === 'SortBy'; }
    document.addEventListener('input', function (e) { if (isToolbarSort(e.target)) e.stopImmediatePropagation(); }, true);
    document.addEventListener('change', function (e) {
      if (!isToolbarSort(e.target)) return;
      e.stopImmediatePropagation();
      var tb = e.target;
      var dr = document.querySelector('#SortBy-mobile');
      if (dr && dr !== tb) {
        dr.value = tb.value;
        dr.dispatchEvent(new Event('input', { bubbles: true }));
        dr.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', tb.value);
        window.location.href = url.toString();
      }
    }, true);
  })();

  /* ---------- 4b) Vídeos dos Produtos (carrossel reels: card central toca o vídeo) ---------- */
  function rghInitReels(root) {
    var track = root.querySelector('.rgh-reels__track');
    var cards = [].slice.call(root.querySelectorAll('.rgh-reels__card'));
    if (!track || cards.length === 0) return;
    var prevBtn = root.querySelector('.rgh-reels__arrow--prev');
    var nextBtn = root.querySelector('.rgh-reels__arrow--next');
    var dur = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var n = cards.length, active = -1, timer = null, scrollT = null, hovering = false;
    function setActive(i) {
      i = (i % n + n) % n;
      if (i === active) return;
      active = i;
      cards.forEach(function (c, k) {
        var on = (k === i);
        c.classList.toggle('is-active', on);
        var v = c.querySelector('video');
        if (v) { if (on) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { try { v.pause(); v.currentTime = 0; } catch (e) {} } }
      });
    }
    function goTo(i) {
      i = (i % n + n) % n;
      setActive(i);
      var c = cards[i];
      track.scrollTo({ left: Math.max(0, c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2), behavior: 'smooth' });
    }
    function nearest() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      cards.forEach(function (c, k) { var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid); if (d < bd) { bd = d; best = k; } });
      return best;
    }
    function start() { clearInterval(timer); timer = setInterval(function () { if (!hovering) goTo(active + 1); }, dur); }
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(active + 1); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(active - 1); start(); });
    track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(function () { setActive(nearest()); }, 90); }, { passive: true });
    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    // Só carrega/toca os vídeos quando a seção entra na tela — evita baixar vídeos
    // (pesados) no load enquanto o cliente nem chegou na seção (a home é longa).
    var started = false;
    function reelsActivate() {
      cards.forEach(function (c) { var v = c.querySelector('video'); if (v && v.preload === 'none') { v.preload = 'metadata'; try { v.load(); } catch (e) {} } });
      if (!started) { setActive(0); started = true; }
      else { var av = cards[active] && cards[active].querySelector('video'); if (av) { var pr = av.play(); if (pr && pr.catch) pr.catch(function () {}); } }
      start();
    }
    function reelsDeactivate() { clearInterval(timer); cards.forEach(function (c) { var v = c.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } }); }
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) reelsActivate(); else reelsDeactivate(); });
      }, { threshold: 0.2 });
      rio.observe(root);
    } else {
      setActive(0);
      start();
    }
  }
  function rghReelsInit() { document.querySelectorAll('.rgh-reels').forEach(rghInitReels); }
  if (document.readyState !== 'loading') rghReelsInit();
  else document.addEventListener('DOMContentLoaded', rghReelsInit);

  /* ---------- 5) Seção Expansível (Energy Space): hover no desktop / clique no mobile ---------- */
  function rghInitExpand(root) {
    var panels = root.querySelectorAll('.rgh-exp__panel');
    if (!panels.length) return;
    var hover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function setActive(p) { panels.forEach(function (x) { x.classList.toggle('is-active', x === p); }); }
    panels.forEach(function (p) {
      if (hover) {
        p.addEventListener('mouseenter', function () { setActive(p); });
      } else {
        p.addEventListener('click', function (e) { if (e.target.closest('a')) return; setActive(p); });
      }
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(p); } });
    });
    if (hover) {
      var wrap = root.querySelector('.rgh-exp__panels');
      if (wrap) wrap.addEventListener('mouseleave', function () { setActive(panels[0]); });
    }
  }
  function rghExpandInit() { document.querySelectorAll('.rgh-exp').forEach(rghInitExpand); }
  if (document.readyState !== 'loading') rghExpandInit();
  else document.addEventListener('DOMContentLoaded', rghExpandInit);

  /* ---------- 6) Guia de Presente: carrossel horizontal com setas ---------- */
  function rghInitGiftGuide(root) {
    var track = root.querySelector('.rgh-gg__track');           // desktop
    var prev = root.querySelector('.rgh-gg__arrow[data-dir="prev"]');
    var next = root.querySelector('.rgh-gg__arrow[data-dir="next"]');
    var tabs = root.querySelectorAll('.rgh-gg__mtab');          // mobile (marcas)
    var panels = root.querySelectorAll('.rgh-gg__mpanel');      // mobile (produtos)
    var mtabsWrap = root.querySelector('.rgh-gg__mtabs');
    var mq = window.matchMedia('(max-width: 749px)');
    var active = 0;

    /* ---- mobile: master-detail (trocar marca → trocar produtos) ---- */
    function setGroup(i) {
      if (!tabs.length) return;
      active = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, ix) { var on = ix === active; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p, ix) { p.classList.toggle('is-active', ix === active); });
      var at = tabs[active];
      if (at && mtabsWrap) { mtabsWrap.scrollTo({ left: at.offsetLeft - mtabsWrap.offsetLeft - 16, behavior: 'smooth' }); }
    }
    tabs.forEach(function (t, ix) { t.addEventListener('click', function () { setGroup(ix); }); });
    // sincroniza a marca ativa quando o usuário arrasta as abas
    if (mtabsWrap) {
      var ts;
      mtabsWrap.addEventListener('scroll', function () {
        clearTimeout(ts);
        ts = setTimeout(function () {
          var best = 0, bestD = Infinity, mid = mtabsWrap.scrollLeft + mtabsWrap.clientWidth / 2;
          tabs.forEach(function (t, ix) { var c = t.offsetLeft + t.offsetWidth / 2; var d = Math.abs(c - mid); if (d < bestD) { bestD = d; best = ix; } });
          if (best !== active) {
            active = best;
            tabs.forEach(function (t, ix) { var on = ix === active; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
            panels.forEach(function (p, ix) { p.classList.toggle('is-active', ix === active); });
          }
        }, 120);
      }, { passive: true });
    }

    /* ---- desktop: rolar o carrossel ---- */
    function steppx() {
      if (!track) return 0;
      var cell = track.querySelector('.rgh-gg__cell');
      var w = cell ? cell.getBoundingClientRect().width : 260;
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 16;
      return Math.round((w + gap) * 2);
    }
    function update() {
      if (!track || mq.matches) return;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = Math.ceil(track.scrollLeft) >= max - 1;
    }
    function onPrev() { if (mq.matches) setGroup(active - 1); else if (track) track.scrollBy({ left: -steppx(), behavior: 'smooth' }); }
    function onNext() { if (mq.matches) setGroup(active + 1); else if (track) track.scrollBy({ left: steppx(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    if (track) track.addEventListener('scroll', update, { passive: true });
    function onModeChange() { if (mq.matches) { if (prev) prev.disabled = false; if (next) next.disabled = false; } else { update(); } }
    if (mq.addEventListener) mq.addEventListener('change', onModeChange);
    window.addEventListener('resize', update);
    onModeChange();
  }
  function rghGiftGuideInit() { document.querySelectorAll('.rgh-gg').forEach(rghInitGiftGuide); }
  if (document.readyState !== 'loading') rghGiftGuideInit();
  else document.addEventListener('DOMContentLoaded', rghGiftGuideInit);

  /* ---------- 7) Barra de benefícios: slider de 1 item no mobile (setas + auto-rotação) ---------- */
  function rghInitUspSlider(root) {
    var track = root.querySelector('.rgh-usp__row');
    if (!track) return;
    var items = track.querySelectorAll('.rgh-usp__item');
    if (items.length < 2) return;
    var prev = root.querySelector('.rgh-usp__nav[data-dir="prev"]');
    var next = root.querySelector('.rgh-usp__nav[data-dir="next"]');
    var mq = window.matchMedia('(max-width: 749px)');
    var idx = 0, timer = null, st = null;
    function go(i, instant) { idx = (i + items.length) % items.length; track.scrollTo({ left: idx * track.clientWidth, behavior: instant ? 'auto' : 'smooth' }); }
    function start() { stop(); timer = setInterval(function () { if (mq.matches) go(idx + 1); }, 4200); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { if (track.clientWidth) idx = Math.round(track.scrollLeft / track.clientWidth); }, 140);
    }, { passive: true });
    // A barra fica ABAIXO do banner full-screen, então o cliente só a vê depois de rolar.
    // Começa sempre no 1º benefício (Frete grátis — o mais importante) e só dispara a auto-rotação
    // quando a barra entra na tela; assim o tempo de carregamento não "come" a vez do Frete e o
    // cliente sempre o vê primeiro (mesma lógica das Linhas Especiais).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!timer) { if (mq.matches) go(0, true); start(); }
          } else { stop(); }
        });
      }, { threshold: 0.5 });
      io.observe(root);
    } else {
      if (mq.matches) go(0, true);
      start();
    }
  }
  function rghUspInit() { document.querySelectorAll('.rgh-usp').forEach(rghInitUspSlider); }
  if (document.readyState !== 'loading') rghUspInit();
  else document.addEventListener('DOMContentLoaded', rghUspInit);

  /* ---------- 8) O Seu Próximo Look: carrossel + modal de produtos ---------- */
  function rghInitLooks(root) {
    if (root.__rghLooks) return;
    root.__rghLooks = true;
    var track = root.querySelector('.rgh-looks__track');
    var prev = root.querySelector('.rgh-looks__arrow[data-dir="prev"]');
    var next = root.querySelector('.rgh-looks__arrow[data-dir="next"]');
    if (track) {
      var stepLk = function () {
        var c = track.querySelector('.rgh-looks__card');
        var w = c ? c.getBoundingClientRect().width : 290;
        var g = parseInt(getComputedStyle(track).columnGap, 10) || 16;
        return Math.round(w + g);
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepLk(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepLk(), behavior: 'smooth' }); });
    }
    // mover modais para o body (evita clipping por overflow/transform de ancestrais)
    root.querySelectorAll('.rgh-looks__modal').forEach(function (m) { document.body.appendChild(m); });

    function openModal(id) {
      var m = document.getElementById(id);
      if (!m) return;
      m.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = m.querySelector('.rgh-looks__modal-close');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal(m) { m.hidden = true; document.body.style.overflow = ''; }
    function closeAll() { document.querySelectorAll('.rgh-looks__modal:not([hidden])').forEach(closeModal); }

    root.querySelectorAll('.rgh-looks__card').forEach(function (card) {
      var id = card.getAttribute('data-modal');
      card.addEventListener('click', function () { openModal(id); });
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(id); } });
    });
    document.querySelectorAll('.rgh-looks__modal').forEach(function (m) {
      m.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', function () { closeModal(m); }); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    // ----- seleção de tamanho + adicionar o look completo ao carrinho -----
    function addLook(modal, btn) {
      var items = modal.querySelectorAll('.rgh-looks__pitem');
      var payload = [], missing = false;
      items.forEach(function (it) {
        it.classList.remove('is-missing');
        var vid = it.getAttribute('data-vid');
        if (!vid) { it.classList.add('is-missing'); missing = true; }
        else payload.push({ id: parseInt(vid, 10), quantity: 1 });
      });
      var hint = modal.querySelector('[data-hint]');
      if (missing) { if (hint) hint.textContent = 'Escolha o tamanho dos itens destacados.'; return; }
      if (!payload.length) return;
      if (hint) hint.textContent = '';
      btn.classList.add('is-loading'); btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading'); btn.disabled = false;
          if (!res.ok) { if (hint) hint.textContent = (res.j && res.j.description) || 'Não foi possível adicionar. Tente de novo.'; return; }
          closeModal(modal);
          rghOpenCartFromData(res.j);
        })
        .catch(function () { btn.classList.remove('is-loading'); btn.disabled = false; if (hint) hint.textContent = 'Erro de conexão. Tente de novo.'; });
    }
    document.querySelectorAll('.rgh-looks__modal').forEach(function (m) {
      if (m.__rghLookBuy) return;
      m.__rghLookBuy = true;
      m.querySelectorAll('.rgh-looks__pitem').forEach(function (it) {
        it.querySelectorAll('.rgh-looks__size').forEach(function (chip) {
          if (chip.disabled) return;
          chip.addEventListener('click', function () {
            it.querySelectorAll('.rgh-looks__size').forEach(function (c) { c.classList.remove('is-selected'); });
            chip.classList.add('is-selected');
            it.setAttribute('data-vid', chip.getAttribute('data-vid'));
            it.classList.remove('is-missing');
          });
        });
      });
      var addBtn = m.querySelector('[data-addall]');
      if (addBtn) addBtn.addEventListener('click', function () { addLook(m, addBtn); });
    });
  }
  function rghLooksInit() { document.querySelectorAll('.rgh-looks').forEach(rghInitLooks); }
  if (document.readyState !== 'loading') rghLooksInit();
  else document.addEventListener('DOMContentLoaded', rghLooksInit);
})();
